// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBZqnoa695HSEA-Vv6NsVT2I7QmEPwG_iY",
  authDomain: "cosmovex.firebaseapp.com",
  projectId: "cosmovex",
  storageBucket: "cosmovex.firebasestorage.app",
  messagingSenderId: "947377067513",
  appId: "1:947377067513:web:deccba2c61701162b15928",
  measurementId: "G-4HE642NZY0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);